import { createContext, useContext, useEffect, useState } from "react";

const KEY = "hh_lang";

const dict = {
  en: {
    // Nav
    "nav.home": "Home",
    "nav.about": "About",
    "nav.services": "Services",
    "nav.searchMaid": "Search Maid",
    "nav.application": "Application",
    "nav.blog": "Blog",
    "nav.resources": "Resources",
    "nav.contact": "Contact",
    "nav.tagline": "Agency · Est. 2006",
    // Common CTAs
    "cta.findHelper": "Find a Helper",
    "cta.submitApp": "Submit Application",
    "cta.startApp": "Start Your Application",
    "cta.speakConsultant": "Speak to a Consultant",
    "cta.sendMessage": "Send Message",
    "cta.chatWhatsApp": "Chat on WhatsApp",
    "cta.viewAll": "Explore all services",
    // Home hero
    "home.overline": "Singapore · Since 2006",
    "home.hero1": "Find the one",
    "home.hero2": "person",
    "home.hero3": "your family",
    "home.hero4": "can trust.",
    "home.subhead": "Not just a helper. The right person for your home. We help Singapore families find helpers who fit their lifestyle, care for their loved ones, and stay for the long term.",
    "home.reviews": "322+ Google reviews",
    "home.years": "20+ years matching families",
    // Home philosophy
    "home.philOverline": "Our Philosophy",
    "home.philTitle": "We match people, not profiles.",
    "home.philosophy1": "Every family is different. Some need someone gentle with elderly parents. Some need someone energetic with young children. Some need an excellent cook. Others simply want someone reliable who will stay for years.",
    "home.philosophy2": "We take the time to understand your family's routines, expectations, communication style and priorities before recommending candidates.",
    "home.philosophy3": "Because the best helper isn't the one with the longest résumé. It's the one who fits your family.",
    // Peace of mind
    "home.pomOverline": "We Sell Peace of Mind",
    "home.pomTitle": "You're choosing someone who will become part of your family's daily life.",
    "home.pomDesc": "You want someone who will care with compassion, keep your children safe, be trustworthy, stay committed, and fit your home's values.",
    "home.pom1": "Care for elderly parents with compassion",
    "home.pom2": "Keep your baby safe and nurtured",
    "home.pom3": "Carefully matched to your family's personality",
    "home.pom4": "Thoroughly screened for reliability and commitment",
    // Differentiators
    "home.whyOverline": "Why Families Choose Us",
    "home.whyTitle": "Creating happy homes starts with the right person.",
    // Services preview
    "home.servicesOverline": "What We Offer",
    "home.servicesTitle": "Services, tailored to your household.",
    // Reviews
    "home.reviewsOverline": "Verified Reviews",
    "home.reviewsTitle1": "322+ Singapore families,",
    "home.reviewsTitle2": "one story",
    "home.reviewsTitle3": "at a time.",
    // Final CTA
    "home.ctaOverline": "Ready to Begin?",
    "home.ctaTitle": "Let's find the RIGHT helper — the FIRST time.",
    // About
    "about.overline": "About Us",
    "about.title1": "Building happy homes since",
    "about.title2": "2006",
    "about.p1": "For nearly two decades, Happy Home Agency has been helping families across Singapore find trusted Filipino domestic helpers through a professional, personalised and reliable matching process.",
    "about.p2": "We believe hiring a helper is more than filling a position — it's choosing someone who will become part of your family's everyday life.",
    "about.p3": "Today, Happy Home Agency is proud to be one of Singapore's trusted employment agencies, serving both local and expatriate families with integrity, professionalism and genuine care.",
    "about.mission": "Our Mission",
    "about.vision": "Our Vision",
    "about.values": "Our Values",
    "about.valuesTitle": "Five principles that guide every match.",
    // Services
    "services.overline": "Services",
    "services.title1": "Three specialties.",
    "services.title2": "One promise.",
    "services.title3": "The right person for your home.",
    "services.cooking": "Cooking",
    "services.housekeeping": "Housekeeping",
    "services.specialNeeds": "Special Needs Care",
    "services.processOverline": "The Happy Home Process",
    "services.processTitle": "Four steps to your right match.",
    // Contact
    "contact.overline": "Get in Touch",
    "contact.title1": "Let's start",
    "contact.title2": "a conversation.",
    "contact.subhead": "Whether you're just beginning your search or you know exactly what you need — our consultants Carol & George are here to help.",
    "contact.visit": "Visit",
    "contact.call": "Call · WhatsApp",
    "contact.email": "Email",
    "contact.hours": "Hours",
    "contact.formOverline": "Send a message",
    "contact.formTitle": "We usually reply the same day.",
    "contact.name": "Your name",
    "contact.phone": "Phone",
    "contact.subject": "Subject",
    "contact.message": "Message",
    // Footer
    "footer.explore": "Explore",
    "footer.visitUs": "Visit Us",
    "footer.reachOut": "Reach Out",
    "footer.rights": "All rights reserved.",
  },
  zh: {
    "nav.home": "首页",
    "nav.about": "关于我们",
    "nav.services": "服务",
    "nav.searchMaid": "寻找女佣",
    "nav.application": "申请表",
    "nav.blog": "博客",
    "nav.resources": "资源",
    "nav.contact": "联络我们",
    "nav.tagline": "自2006年成立",
    "cta.findHelper": "寻找帮佣",
    "cta.submitApp": "提交申请",
    "cta.startApp": "开始您的申请",
    "cta.speakConsultant": "咨询顾问",
    "cta.sendMessage": "发送信息",
    "cta.chatWhatsApp": "WhatsApp 联系",
    "cta.viewAll": "浏览所有服务",
    "home.overline": "新加坡 · 自2006",
    "home.hero1": "为您的家庭找到",
    "home.hero2": "值得信赖",
    "home.hero3": "的那一位。",
    "home.hero4": "",
    "home.subhead": "不只是女佣，而是最适合您家庭的人。我们帮助新加坡家庭找到既能融入生活方式，又能长期陪伴家人的帮佣。",
    "home.reviews": "322+ 谷歌评价",
    "home.years": "20+ 年配对经验",
    "home.philOverline": "我们的理念",
    "home.philTitle": "我们匹配的是人，不只是履历。",
    "home.philosophy1": "每个家庭都不同。有的需要照顾长辈的温柔女佣，有的需要陪伴孩子活力充沛的帮手，有的希望有一位出色的厨师，有的则希望找到一位能长期留下来的可靠伙伴。",
    "home.philosophy2": "在推荐候选人之前，我们会花时间了解您的家庭作息、期望、沟通方式与优先事项。",
    "home.philosophy3": "因为最好的帮佣，不是履历最长的那一位，而是最适合您家庭的那一位。",
    "home.pomOverline": "我们提供的是安心",
    "home.pomTitle": "您正在选择的，是将成为家庭一份子的那个人。",
    "home.pomDesc": "您想找的人应具备同理心、能守护孩子、值得信赖、愿意长期承诺，并契合家中价值观。",
    "home.pom1": "以体贴之心照顾年长的父母",
    "home.pom2": "让宝宝在安全与温暖中成长",
    "home.pom3": "精心匹配您家庭的个性",
    "home.pom4": "经过严格筛选，确保可靠与承诺",
    "home.whyOverline": "为何选择我们",
    "home.whyTitle": "幸福家庭的起点，是找对人。",
    "home.servicesOverline": "我们提供的服务",
    "home.servicesTitle": "量身打造，贴心到位。",
    "home.reviewsOverline": "真实评价",
    "home.reviewsTitle1": "322+ 新加坡家庭，",
    "home.reviewsTitle2": "每一个",
    "home.reviewsTitle3": "都是故事。",
    "home.ctaOverline": "准备好开始了吗？",
    "home.ctaTitle": "让我们为您一次找到合适的帮佣。",
    "about.overline": "关于我们",
    "about.title1": "自",
    "about.title2": "2006 年 起，建立幸福家庭",
    "about.p1": "近二十年来，Happy Home Agency 通过专业、贴心、可靠的配对流程，协助新加坡的家庭找到值得信赖的菲律宾家庭帮佣。",
    "about.p2": "我们相信，聘请帮佣不只是填补一个职位，而是选择一位将融入家庭日常生活的人。",
    "about.p3": "今天，Happy Home Agency 是新加坡最受信赖的家庭雇佣中介之一，以诚信、专业与真诚服务本地与外派家庭。",
    "about.mission": "我们的使命",
    "about.vision": "我们的愿景",
    "about.values": "我们的价值观",
    "about.valuesTitle": "五项原则，指引每一次配对。",
    "services.overline": "服务",
    "services.title1": "三大专长。",
    "services.title2": "一个承诺。",
    "services.title3": "为您的家找到合适的那位。",
    "services.cooking": "烹饪",
    "services.housekeeping": "家务管理",
    "services.specialNeeds": "特殊需求照护",
    "services.processOverline": "Happy Home 流程",
    "services.processTitle": "四个步骤，找到合适之人。",
    "contact.overline": "联系我们",
    "contact.title1": "开始",
    "contact.title2": "一段对话。",
    "contact.subhead": "无论您刚开始寻找，或已明确所需——我们的顾问 Carol 与 George 随时为您服务。",
    "contact.visit": "亲临",
    "contact.call": "电话 · WhatsApp",
    "contact.email": "电邮",
    "contact.hours": "营业时间",
    "contact.formOverline": "发送留言",
    "contact.formTitle": "我们通常当天回复。",
    "contact.name": "您的姓名",
    "contact.phone": "电话",
    "contact.subject": "主题",
    "contact.message": "留言",
    "footer.explore": "导览",
    "footer.visitUs": "参访我们",
    "footer.reachOut": "联络我们",
    "footer.rights": "版权所有。",
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem(KEY) || "en");
  useEffect(() => { localStorage.setItem(KEY, lang); document.documentElement.lang = lang === "zh" ? "zh-CN" : "en"; }, [lang]);
  const t = (k) => {
    const v = dict[lang]?.[k];
    return v !== undefined ? v : (dict.en[k] || k);
  };
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext) || { lang: "en", setLang: () => {}, t: (k) => (dict.en[k] !== undefined ? dict.en[k] : k) };
